<template>
  <div>
    <ErrorAlert
      :show="alert.error"
      :message="alert.message"
      @hide-alert="hideError"
    />
    <SuccessAlert
      :show="alert.success"
      :message="alert.message"
      @hide-alert="hideSuccess"
    />

    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-auto">
          <h3><strong>Schedule</strong> configuration {{ title }}</h3>
          <p class="mt-4 mb-0">All fields are required</p>
        </div>
      </div>

      <div class="row mt-3 mb-0 form">
        <div class="col-md-8 col-xl-8 col-12">
          <div class="form-card">
            <b-form>
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-0 rule-label">Schedule name</label>
                    <b-form-input
                      :plaintext="nameReadonly"
                      v-model="form.name"
                      type="text"
                      placeholder=""
                      class="input-height mt-1"
                    ></b-form-input>
                    <div class="input-box">
                      <p v-show="checkRepName" class="input-alert mb-0 mt-0">
                        Special characters are not allowed
                      </p>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 rule-label">Status</label>
                    <b-form-select
                      v-model="form.state"
                      :options="statusOpt"
                      class="input-height mt-1"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <b-form-group>
                <label class="mt-0 rule-label">Description</label>
                <b-form-input
                  v-model="form.description"
                  type="text"
                  placeholder="description"
                  class="input-height mt-1"
                ></b-form-input>
              </b-form-group>

              <aws-cron v-model="form.scheduleExpression" />
              <b-form-group>
                <label class="mt-0 rule-label"
                  >Schedule Expression(sample: cron(0 18 ? * * *))</label
                >
                <b-form-input
                  v-model="form.scheduleExpression"
                  type="text"
                  placeholder=""
                  class="input-height mt-1"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <label class="mt-0 rule-label">Order Pull</label>
                <b-form-select
                  v-model="pullId"
                  :options="inputList"
                  class="input-height mt-1"
                ></b-form-select>
              </b-form-group>

              <b-button
                type="button"
                variant="primary"
                class="submit-button"
                v-if="enableButton"
                @click="submit"
              >
                Submit
              </b-button>
              <b-button type="button" class="disabled-button" disabled v-else>
                Submit
              </b-button>&nbsp;
              <b-button
                type="button"
                variant="primary"
                class="submit-button"
                @click="close"
              >
                Close
              </b-button>
            </b-form>
          </div>
        </div>
      </div>
      <div class="page-break"></div>
    </div>
  </div>
</template>

<script>
import ErrorAlert from "@/components/alerts/error.vue";
import SuccessAlert from "@/components/alerts/success.vue";
import AWSCron from "@/components/report/aws-cron.vue";
import { uuid } from "vue-uuid";

export default {
  components: {
    ErrorAlert,
    SuccessAlert,
    "aws-cron": AWSCron,
  },
  data() {
    return {
      title: "",
      type: "",
      nameReadonly: false,
      inputList: [{ text: "empty", value: "" }],
      pullId: "",
      form: {
        name: "EXP_",
        state: "ENABLED",
        description: "",
        scheduleExpression: "",
        groupName: "exporter-service",
        input: "",
        timezone: "America/Winnipeg"
      },

      alert: {
        error: false,
        message: "",
      },

      statusOpt: [
        { text: "Enabled", value: "ENABLED" },
        { text: "Disabled", value: "DISABLED" },
      ],
    };
  },
  created() {
    if (this.$route.params.editedItem) {
      console.log("Editing item", this.$route.params.editedItem);
      this.form = this.$route.params.editedItem;
      this.pullId = this.form.input.uuid;
      this.form.scheduleExpression = this.form.scheduleExpression
        .replace(/cron[(]/g, "")
        .replace(/[)]/g, "");
      this.nameReadonly = true;
      this.title = "update";
    } else {
      this.title = "create";
    }

    this.axios
      .get(process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/config")
      .then((response) => {
        if (response.data && response.data.length > 0) {
          for (const element of response.data) {
            const item = {
              text: element.reportName,
              value: element.id
            };
            this.inputList.push(item);
          }
        }
      });
  },
  methods: {
    close() {
      this.$router.push({ name: "SchedulesList" });
    },
    async submit() {
      if (!this.form.name) {
        this.alert = {
          message: "Please enter a name for the schedule",
          error: true,
          success: false,
        };
        return;
      }
      if (!this.pullId) {
        this.alert = {
          message: "Please select a order pull for the schedule",
          error: true,
          success: false,
        };
        return;
      }
      if (!this.form.scheduleExpression || !this.form.scheduleExpression.split(" ")[4]) {
        this.alert = {
          message: "Please select at least one day of the week",
          error: true,
          success: false,
        };
        return;
      }

      if (!this.form.name.toUpperCase().startsWith("EXP_")) {
        this.form.name = "EXP_" + this.form.name;
      }
      this.form.input = `{ "uuid": "${this.pullId}" }`;

      let response;
      if (this.title === "update") {
        response = await this.axios.put(
          process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/schedules",
          this.form
        );
      } else {
        response = await this.axios.post(
          process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/schedules",
          this.form
        );
      }

      if (response && response.status === 200) {
        this.alert = {
          message: "Schedule submitted successfully",
          error: false,
          success: true,
        };
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$router.push({ name: "SchedulesList" });
      } else {
        this.alert = {
          message: "Failed to submit schedule",
          error: true,
          success: false,
        };
      }
    },
    hideError() {
      this.alert.error = false;
    },
    hideSuccess() {
      this.alert.success = false;
    },
  },
  computed: {
    checkRepName() {
      if (this.form.name && !/^[0-9A-Za-z_ ]+$/.test(this.form.name)) {
        return true;
      }
      return false;
    },
    enableButton() {
      if (this.form.name && /^[0-9A-Za-z_ ]+$/.test(this.form.name)) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "form.name": {
      handler: function () {
        // this.form.name = this.form.name.replace(" ", "_");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/form.scss";

.card {
  width: 100%;
  border: none;
}

.rule-label {
  font-weight: 600;

  .weight {
    font-weight: 400;
  }

  span {
    font-weight: 400;
  }
}

.upper {
  text-transform: uppercase;
}

#checkbox-group,
.custom-select a:hover,
a:active,
a:focus {
  outline: 0;
}

.page-break {
  width: 100%;
  height: 52px;
}
</style>
